import React, { Component } from 'react';
import { spring, StaggeredMotion } from 'react-motion';

import { ShowcaseCollectionCard, APIHandler, StorageHandler } from 'C4';
import { baseAppId, storageKeys } from 'settings';

export default class ShowcaseCollection extends Component {
  constructor(props) {
    super(props);

    this.timer = null;
    this.state = {
      showcaseCollection: [],
      email: 'Guest',
    };
  }

  componentDidMount() {
    this.getUser();
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  getUser() {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'Guest';
      if (userObj) {
        ({ email } = userObj);
      }
      this.setState({ email });
      this.init();
    });
  }

  init() {
    const showcaseCollection = this.props.stands;
    const { category } = this.props;
    const { email } = this.state;
    const params = new URLSearchParams(window.location.search);
    const colId = params.get('id');

    const startingValues = Object.keys(showcaseCollection).map(() => ({
      data: 0,
      pos: 20,
    }));

    // Returned in search analytics
    let ids = '';
    showcaseCollection.map((showcase, i) => {
      ids = `${ids}&booth_id[]=${showcase.company_id}`;
    });
    APIHandler.trackSearch(ids, email).then((res) => {
    });
    
    this.setState({
      showcaseCollection: (
        <StaggeredMotion
          defaultStyles={startingValues}
          styles={prevInterpolatedStyles =>
            prevInterpolatedStyles.map((_, i) =>
              (i === 0
                ? {
                    data: spring(1, { stiffness: 320, damping: 28 }),
                    pos: spring(0, { stiffness: 320, damping: 28 }),
                  }
                : {
                    data: spring(prevInterpolatedStyles[i - 1].data, {
                      stiffness: 320,
                      damping: 28,
                    }),
                    pos: spring(prevInterpolatedStyles[i - 1].pos, {
                      stiffness: 320,
                      damping: 28,
                    }),
                  }))
          }
        >
          {styles => (
            <React.Fragment>
              {showcaseCollection.map((showcase, i) => {
                const {
                  title,
                  icon,
                  type,
                  id,
                  company_id,
                  exhibition_id,
                  description,
                } = showcase;

                let currentCountry = showcaseCollection[i].country;
                let previousCountry = '';
                if (i !== 0) {
                  previousCountry = showcaseCollection[i - 1].country;
                  currentCountry = showcaseCollection[i].country;
                }

                const style = {
                  opacity: `${styles[i].data}`,
                  transform: `translateY(${styles[i].pos}%)`,
                };

                if (!title) {
                  return;
                }

                return (
                  <React.Fragment>
                    <div
                      key={id}
                      className="ShowcaseCollectionCard__Animated"
                      style={style}
                    >
                      <ShowcaseCollectionCard
                        appId={baseAppId}
                        key={id}
                        index={i}
                        image={icon}
                        subtitle={description}
                        title={title}
                        type={type}
                        url={`/main/hotel-showroom/showcase-collection/${category}/${company_id}?id=${exhibition_id}`}
                        itemID={company_id}
                      />
                    </div>
                  </React.Fragment>
                );
              })}
            </React.Fragment>
          )}
        </StaggeredMotion>
      ),
    });
  }

  render() {
    return (
      <div className="showcaseCollection__Grid">
        {this.state.showcaseCollection}
        <style>{'\
        .fancybox-slide--iframe .fancybox-content { max-width  : 960px; margin: 0; } '}
        </style>
      </div>
    );
  }
}
